<template>
  <div class="JOB-LIST-ITEM-PLACEHOLDER">
    <placeholder />
  </div>
</template>

<script>
import JobListItemPlaceholder from '@/views/Dashboard/components/JobListItemPlaceholder';

export default {
  name: 'job-list-item-placeholder',
  components: {
    Placeholder: JobListItemPlaceholder,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .JOB-LIST-ITEM-PLACEHOLDER {
    @include padding-left(4, $md: 7);
    display: flex;
    flex: 0 0 auto;
    min-height: $job-list-item-min-height;
    padding-top: 2*$unit;
    padding-right: 2*$unit;
    padding-bottom: 2*$unit;
    background-color: white;
    border-bottom: 1px solid $color-gray30;
  }
</style>
